module.exports = __webpack_public_path__ + "static/attractions-and-transportation__hero.f4a2eeaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/attractions-and-transportation__hero.jpg
// module id = 486
// module chunks = 249749550194671